module.exports = __webpack_public_path__ + "img/flex.7d1211c2.svg";